import React, {PropsWithChildren, useRef} from 'react';
import './drawerMenu.scss';
import Button from '../button/Button';

interface DrawerProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

function DrawerMenu({open, setOpen, children}: PropsWithChildren<DrawerProps>): JSX.Element {
    const drawerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={drawerRef} className={`c-drawer ${open ? 'c-drawer--open' : ''}`}>
            <div className="c-drawer__overlay" onClick={() => setOpen(false)} />
            <div className="c-drawer__drawer">
                <div className="c-drawer__close">
                    <Button leading="ph:x-bold" square size="md" variant="ghost" onClick={() => setOpen(false)} />
                </div>
                {children}
            </div>
        </div>
    );
}

export default DrawerMenu;
